import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuthForm } from "@/hooks/useAuthForm";

export const AuthForm = ({ mode }) => {
  const { form, loading, submitAuth, updateForm } = useAuthForm(mode);
  const isRegistering = mode === "register";

  return (
    <form onSubmit={submitAuth} className="space-y-5" data-testid="auth-form">
      {isRegistering && (
        <div className="space-y-2" data-testid="auth-name-field-group">
          <Label htmlFor="name" className="text-[#1A3626]">Name</Label>
          <Input id="name" data-testid="auth-name-input" value={form.name} onChange={(event) => updateForm("name", event.target.value)} required className="h-12 rounded-xl border-[#E5E1D8] bg-white text-[#1A3626] focus-visible:ring-[#C87961]" />
        </div>
      )}
      <div className="space-y-2" data-testid="auth-email-field-group">
        <Label htmlFor="email" className="text-[#1A3626]">Email</Label>
        <Input id="email" data-testid="auth-email-input" type="email" value={form.email} onChange={(event) => updateForm("email", event.target.value)} required className="h-12 rounded-xl border-[#E5E1D8] bg-white text-[#1A3626] focus-visible:ring-[#C87961]" />
      </div>
      <div className="space-y-2" data-testid="auth-password-field-group">
        <Label htmlFor="password" className="text-[#1A3626]">Password</Label>
        <Input id="password" data-testid="auth-password-input" type="password" minLength={8} value={form.password} onChange={(event) => updateForm("password", event.target.value)} required className="h-12 rounded-xl border-[#E5E1D8] bg-white text-[#1A3626] focus-visible:ring-[#C87961]" />
      </div>
      <Button type="submit" disabled={loading} data-testid="auth-submit-button" className="h-12 w-full rounded-full bg-[#1A3626] text-white transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#4A5D4E]">
        {loading && <Loader2 className="animate-spin" size={16} />}
        {isRegistering ? "Create account" : "Sign in"}
      </Button>
    </form>
  );
};